// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import Select from "react-select";
// import { useDispatch } from "react-redux";
// import { updateProfleAction } from "../../../redux/actions/user/userAction";
// import { connect } from "react-redux";
// import { DialogLeavingPage } from "../../utils/core/blocknavigation/DialogLeavingPage";
// import { useNavigatingAway } from "../../utils/core/blocknavigation/useNavigatingAway";

// export const Qualification = (props) => {
//   const customStyles = {
//     control: (base, state) => ({
//       ...base,
//       top: "5px",
//       // Overwrittes the different states of border
//       borderColor: state.isFocused ? "#309CCA" : "#309CCA",
//     }),
//   };

//   const groupByKey = (array, key) => {
//     return array.reduce((hash, obj) => {
//       if (obj[key] === undefined) return hash;
//       return Object.assign(hash, {
//         [obj[key]]: (hash[obj[key]] || []).concat(obj),
//       });
//     }, {});
//   };

//   const dispatch = useDispatch();
//   const [groupedOptions, setGroupedOptions] = useState([]);
//   const [inputData, setInputData] = useState([]);
//   const [education, setEducation] = useState([]);
//   const [isEnable, setIsEnable] = useState({
//     save: false,
//   });
//   const [canShowDialogLeavingPage, setCanShowDialogLeavingPage] =
//     useState(false);
//   const [showDialogLeavingPage, confirmNavigation, cancelNavigation] =
//     useNavigatingAway(canShowDialogLeavingPage);

//   const handleAddFormChange = () => {
//     setEducation((prevState) => [...prevState, null]);
//   };

//   const handleChange = (event, index) => {
//     setIsEnable((prevState) => ({ ...prevState, save: true }));
//     setCanShowDialogLeavingPage(true);
//     const values = [...education];
//     values[index] = event["id"];
//     setEducation(values);
//   };

//   const handleFormSubmit = (event) => {
//     event.preventDefault();
//     const updateRegion = {
//       userId: inputData.userId,
//       education: education,
//     };
//     dispatch(updateProfleAction(inputData.userId, updateRegion));
//     setIsEnable((prevState) => ({ ...prevState, save: false }));
//     setCanShowDialogLeavingPage(false);
//   };

//   const handleRemoveFormChange = (index) => {
//     setIsEnable((prevState) => ({ ...prevState, save: true }));
//     setCanShowDialogLeavingPage(true);
//     const values = [...education];
//     values.splice(index, 1);
//     setEducation(values);
//   };

//   useEffect(() => {
//     if (Object.keys(props.profile).length > 0) {
//       const education = {
//         userId: props.profile.userId,
//       };
//       setInputData(education);
//       setEducation(
//         props.profile.education && props.profile.education.length === 0
//           ? [null]
//           : props.profile.education
//       );
//     }

//     // Grouped Select Options
//     if (props.qualifications !== undefined && props.educations.length > 0) {
//       const data = groupByKey(props.qualifications, "education_grade");
//       const dataOptions = [
//         {
//           label:
//             props.educations[
//               props.educations.findIndex((val) => val["id"] === 1)
//             ].education,
//           options: data[1],
//         },
//         {
//           label:
//             props.educations[
//               props.educations.findIndex((val) => val["id"] === 2)
//             ].education,
//           options: data[2],
//         },
//         {
//           label:
//             props.educations[
//               props.educations.findIndex((val) => val["id"] === 3)
//             ].education,
//           options: data[3],
//         },
//       ];
//       setGroupedOptions(dataOptions);
//     }
//   }, [props.profile, props.qualifications, props.educations]);

//   return (
//     <div className="row">
//       <DialogLeavingPage
//         showDialog={showDialogLeavingPage}
//         setShowDialog={setCanShowDialogLeavingPage}
//         confirmNavigation={confirmNavigation}
//         cancelNavigation={cancelNavigation}
//         title={"Qualifications"}
//       />
//       <div className="row-icon">
//         <img src="\assets\images\profile-page\icon3.png" alt="" />
//         <img
//           className="completed"
//           src="/assets/images/profile-page/education_active_icon.svg"
//           alt=""
//         />
//       </div>
//       <div className="col-12 ">
//         <div className="timeline-border-box">
//           <h5>Qualifications</h5>
//           <div className="row" >
//           {education &&
//             education.map((row, index) => {
//               const isHighestQualification = index === 0;
//               return (
               
//                   <div className="col-12 parent-col" key={index}>
//                     <div className="row cloneRowTarget  ">
//                       <div
//                         className="col-md-6 col-12"
//                         style={{ paddingTop: "2%" }}
//                       >
//                         <label className="field-label">
//                         {isHighestQualification ? "Highest Qualification" : "Qualification"}
//                         </label>
//                       </div>
//                       <div
//                         className="col-md-5 col-10"
//                         style={{ paddingTop: "1%" }}
//                       >
//                         <Select
//                           id="education"
//                           name="education"
//                           value={
//                             props.qualifications &&
//                             props.qualifications.find(
//                               (qualificaion) => qualificaion.id === row
//                             )
//                           }
//                           options={groupedOptions}
//                           getOptionLabel={(option) => option.education}
//                           getOptionValue={(option) => option.id}
//                           onChange={(event) => handleChange(event, index)}
//                           placeholder="Choose.."
//                           isClearable={true}
//                           styles={customStyles}
//                           isOptionDisabled={(option) =>
//                             education.includes(option.id)
//                           }
//                         />
//                       </div>
                    
//                         {index !== 0 ? (
//                           <div className="col-md-1 col-12  text-right clone-row-btn-holder">
//                             <Link
//                               to=""
//                               style={{ cursor: "pointer" }}
//                               onClick={() => handleRemoveFormChange(index)}
//                               className="cloneTargetTrigger"
//                             >
//                               -
//                             </Link>
//                           </div>
//                         ) : (
//                           <></>
//                         )}
//                     </div>
//                   </div>
                
//               );
//             })}
//           <div className="col-12 text-right clone-row-btn-holder">
//             <Link
//               to=""
//               style={{ cursor: "pointer" }}
//               onClick={handleAddFormChange}
//               className="cloneTargetTrigger"
//             >
//               +
//             </Link>
//           </div>
//           </div>
//           <br />{" "}
//           <div className="col text-right ">
//             {isEnable.save ? (
//               <Link className="edit-btn" to="" onClick={handleFormSubmit}>
                
//                 <span>
//                   <img src="/assets/images/icons/save.png" alt="" />Save
//                 </span>
//               </Link>
//             ) : (
//               ""
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const mapStateToProps = (state) => {
//   const user = state.user.user;
//   const profile = state.user.profile;
//   const educations = state.admin.educations;
//   const qualifications = state.admin.qualifications;

//   return {
//     user: user,
//     profile: profile,
//     educations: educations,
//     qualifications: qualifications,
//   };
// };

// const mapDispatchToProps = {};

// export default connect(mapStateToProps, mapDispatchToProps)(Qualification);




///////////////////////////////////////////////////////////////////////

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { updateProfleAction } from "../../../redux/actions/user/userAction";
import { connect } from "react-redux";
import { DialogLeavingPage } from "../../utils/core/blocknavigation/DialogLeavingPage";
import { useNavigatingAway } from "../../utils/core/blocknavigation/useNavigatingAway";

export const Qualification = (props) => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      top: "5px",
      // Overwrittes the different states of border
      borderColor: state.isFocused ? "#309CCA" : "#309CCA",
    }),
  };

  const MAX_QUALIFICATIONS = 5; // ⭐ Max limit

  const groupByKey = (array, key) => {
    return array.reduce((hash, obj) => {
      if (obj[key] === undefined) return hash;
      return Object.assign(hash, {
        [obj[key]]: (hash[obj[key]] || []).concat(obj),
      });
    }, {});
  };

  const dispatch = useDispatch();
  const [groupedOptions, setGroupedOptions] = useState([]);
  const [inputData, setInputData] = useState([]);
  const [education, setEducation] = useState([]);
  const [isEnable, setIsEnable] = useState({
    save: false,
  });
  const [canShowDialogLeavingPage, setCanShowDialogLeavingPage] =
    useState(false);
  const [showDialogLeavingPage, confirmNavigation, cancelNavigation] =
    useNavigatingAway(canShowDialogLeavingPage);

  const handleAddFormChange = () => {
    // ⭐ Enforce max 5 qualifications
    if (education.length >= MAX_QUALIFICATIONS) {
      alert(`You can add up to ${MAX_QUALIFICATIONS} qualifications only.`);
      return;
    }

    setIsEnable((prevState) => ({ ...prevState, save: true }));
    setCanShowDialogLeavingPage(true);

    setEducation((prevState) => [...prevState, null]);
  };

  const handleChange = (event, index) => {
    setIsEnable((prevState) => ({ ...prevState, save: true }));
    setCanShowDialogLeavingPage(true);
    const values = [...education];
    values[index] = event["id"];
    setEducation(values);
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    const updateRegion = {
      userId: inputData.userId,
      education: education,
    };
    dispatch(updateProfleAction(inputData.userId, updateRegion));
    setIsEnable((prevState) => ({ ...prevState, save: false }));
    setCanShowDialogLeavingPage(false);
  };

  const handleRemoveFormChange = (index) => {
    setIsEnable((prevState) => ({ ...prevState, save: true }));
    setCanShowDialogLeavingPage(true);
    const values = [...education];
    values.splice(index, 1);
    setEducation(values);
  };

  useEffect(() => {
    if (Object.keys(props.profile).length > 0) {
      const education = {
        userId: props.profile.userId,
      };
      setInputData(education);
      setEducation(
        props.profile.education && props.profile.education.length === 0
          ? [null]
          : props.profile.education
      );
    }

    // Grouped Select Options
    if (props.qualifications !== undefined && props.educations.length > 0) {
      const data = groupByKey(props.qualifications, "education_grade");
      const dataOptions = [
        {
          label:
            props.educations[
              props.educations.findIndex((val) => val["id"] === 1)
            ].education,
          options: data[1],
        },
        {
          label:
            props.educations[
              props.educations.findIndex((val) => val["id"] === 2)
            ].education,
          options: data[2],
        },
        {
          label:
            props.educations[
              props.educations.findIndex((val) => val["id"] === 3)
            ].education,
          options: data[3],
        },
      ];
      setGroupedOptions(dataOptions);
    }
  }, [props.profile, props.qualifications, props.educations]);

  // ⭐ Remaining count for UI
  const remaining =
    MAX_QUALIFICATIONS - (education && education.length ? education.length : 0);

  return (
    <div className="row">
      <DialogLeavingPage
        showDialog={showDialogLeavingPage}
        setShowDialog={setCanShowDialogLeavingPage}
        confirmNavigation={confirmNavigation}
        cancelNavigation={cancelNavigation}
        title={"Qualifications"}
      />
      <div className="row-icon">
        <img src="\assets\images\profile-page\icon3.png" alt="" />
        <img
          className="completed"
          src="/assets/images/profile-page/education_active_icon.svg"
          alt=""
        />
      </div>
      <div className="col-12 ">
        <div className="timeline-border-box">
          <h5>Qualifications</h5>
          <div className="row" >
          {education &&
            education.map((row, index) => {
              const isHighestQualification = index === 0;
              return (
               
                  <div className="col-12 parent-col" key={index}>
                    <div className="row cloneRowTarget  ">
                      <div
                        className="col-md-6 col-12"
                        style={{ paddingTop: "2%" }}
                      >
                        <label className="field-label">
                        {isHighestQualification ? "Highest Qualification" : "Qualification"}
                        </label>
                      </div>
                      <div
                        className="col-md-5 col-10"
                        style={{ paddingTop: "1%" }}
                      >
                        <Select
                          id="education"
                          name="education"
                          value={
                            props.qualifications &&
                            props.qualifications.find(
                              (qualificaion) => qualificaion.id === row
                            )
                          }
                          options={groupedOptions}
                          getOptionLabel={(option) => option.education}
                          getOptionValue={(option) => option.id}
                          onChange={(event) => handleChange(event, index)}
                          placeholder="Choose.."
                          isClearable={true}
                          styles={customStyles}
                          isOptionDisabled={(option) =>
                            education.includes(option.id)
                          }
                        />
                      </div>
                    
                        {index !== 0 ? (
                          <div className="col-md-1 col-12  text-right clone-row-btn-holder">
                            <Link
                              to=""
                              style={{ cursor: "pointer" }}
                              onClick={() => handleRemoveFormChange(index)}
                              className="cloneTargetTrigger"
                            >
                              -
                            </Link>
                          </div>
                        ) : (
                          <></>
                        )}
                    </div>
                  </div>
                
              );
            })}
             
            {/* ⭐ Remaining counter */}
            {/* <div className="col-12 text-right" style={{ marginTop: "5px" }}>
              <small
                style={{
                  fontSize: "12px",
                  color: remaining === 0 ? "red" : "#555",
                }}
              >
                {remaining} remaining
              </small>
            </div> */}

            {/* ⭐ Show + button only if under limit */}
            {education.length < MAX_QUALIFICATIONS && (
              <div className="col-12 text-right clone-row-btn-holder">
                <Link
                  to=""
                  style={{ cursor: "pointer" }}
                  onClick={handleAddFormChange}
                  className="cloneTargetTrigger"
                >
                  +
                </Link>
                
              </div>
            )}
          </div>

          <br />
          <div className="col text-right ">
            {isEnable.save ? (
              <Link className="edit-btn" to="" onClick={handleFormSubmit}>
                <span>
                  <img src="/assets/images/icons/save.png" alt="" />
                  Save
                </span>
              </Link>
            ) : (
              ""
            )}
            <p
              style={{
                fontSize: "12px",
                textAlign: "left",
                color:  "#555" // red when max reached
              }}
            >
              {remaining > 0
                ? `${remaining} remaining`
                : "Maximum number of qualifications added."}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const user = state.user.user;
  const profile = state.user.profile;
  const educations = state.admin.educations;
  const qualifications = state.admin.qualifications;

  return {
    user: user,
    profile: profile,
    educations: educations,
    qualifications: qualifications,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Qualification);